import { IUser } from '@okcargo-apps/shared-domain';
import { IUserFormValue } from './users-store.model';

export function mapUserToFormValue(user: IUser): IUserFormValue {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    phone: user.phone,
    enabled: user.enabled,
    roles: [...user.roles],
  };
}

/**
 * Builds the domain user from the form value. On edit, `original` is passed so that the raw
 * backend categories are preserved (only the role-related ones are re-derived in the command
 * mapper).
 */
export function mapFormValueToUser(value: IUserFormValue, id: string, original: IUser | null = null): IUser {
  return {
    id,
    firstName: value.firstName,
    lastName: value.lastName,
    email: value.email,
    phone: value.phone,
    categories: original?.categories ?? [],
    roles: value.roles,
    enabled: value.enabled,
    isCarrierContact: original?.isCarrierContact ?? false,
    isShipperContact: original?.isShipperContact ?? false,
    userId: original?.userId,
    createdAt: original?.createdAt,
    updatedAt: original?.updatedAt,
  };
}
